export default __webpack_public_path__ + "static/media/semcasting-icon-00a9c5.a65a4cdb.svg";